import React from "react";
import { SearchIcon } from "@aureskonnect/react-ui";
import { useTemplateData } from "@constants/template";
import { store } from "../CoverPage/store";
import { useSnapshot } from "valtio";

interface BannerProps {
    bannier?: boolean;
    showTitle?: boolean;
    showDescription?: boolean;
    showSearch?: boolean;
    imagePath?: string[];
}

const Banner = React.memo(
    ({
        showTitle = true,
        showDescription = true,
        showSearch = true,
        imagePath = ["SiteWeb", "ChoixBoutique", "Header", "Image"],
    }: BannerProps) => {
        const { getImageUrlDesktop, iuud, getNestedValue } = useTemplateData();
        const imageUrl = getImageUrlDesktop(imagePath, iuud);

        const titleData = getNestedValue<any>([
            ...imagePath.slice(0, -1),
            "Title",
        ]);
        const descriptionData = getNestedValue<any>([
            ...imagePath.slice(0, -1),
            "Description",
        ]);
        const colorTitle = getNestedValue<string>([
            "SiteWeb",
            "Divers",
            "CouleurTitre",
        ]);
        const { selectedLanguage } = useSnapshot(store);
        const titleText = titleData?.[selectedLanguage]?.trim() || "";
        const descriptionText =
            descriptionData?.[selectedLanguage]?.trim() || "";

        return (
            <section className="banner-section">
                <div className="banner">
                    {imageUrl !== "" && (
                        <img
                            src={imageUrl}
                            alt=""
                            className="banner-image"
                            loading="lazy"
                            style={{
                                objectFit: "fill",
                            }}
                            onError={(e) => {
                                (e.target as HTMLImageElement).src = "";
                            }}
                        />
                    )}

                    <div className="banner-content">
                        {showTitle && titleText && (
                            <h1 style={{ color: `${colorTitle}` }}>
                                {titleText}
                            </h1>
                        )}
                        {showDescription && descriptionText && (
                            <p style={{ color: `${colorTitle}` }}>
                                {descriptionText}
                            </p>
                        )}

                        {showSearch && (
                            <div className=" search-box">
                                <input
                                    type="text"
                                    placeholder="Trouvez votre boutique"
                                    aria-label="Search for your shop"
                                    className="not-allowed-icon__clz"
                                />
                                <button
                                    type="button"
                                    title="Search"
                                    aria-label="Search"
                                    className="not-allowed-icon__clz"
                                >
                                    <SearchIcon height={25} width={25} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
);

Banner.displayName = "Banner";

export default Banner;
